import Form from 'react-bootstrap/Form';

function FundingsSearchForm({ search, searchKey, spinner }) {
  return (
    <Form.Control
      className="bo-search"
      name="search"
      id="search"
      placeholder="Search"
      disabled={spinner}
      defaultValue={search}
      onKeyPress={e => searchKey('fundings', e)}
    />
  );
}

export default FundingsSearchForm;
